import script from "./FooterSub.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterSub.vue?vue&type=script&lang=ts&setup=true"

import "./FooterSub.vue?vue&type=style&index=0&id=26316caa&lang=scss"

const __exports__ = script;

export default __exports__